import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import { SidebarItem } from '@traton/devportal-env-kit-app';
import { useMarketplaceAccess } from '../../hooks/useMarketplaceAccess';

export const AgenticMarketplaceSidebarItem = () => {
  const { hasReadAccess } = useMarketplaceAccess();

  if (!hasReadAccess) return null;

  return (
    <SidebarItem
      icon={StorefrontOutlinedIcon}
      to="/agentic-marketplace"
      text="AI Marketplace"
      pluginId="agentic-marketplace"
      data-testid="agentic-marketplace-sidebar-button"
    />
  );
};
